import React, {Component} from 'react';
import {connect} from 'react-redux';
import Drawer from 'material-ui/Drawer';
import classNames from 'classnames';
import {Router} from 'react-router-dom'
import RoutesList from '../routers/routesList.js';
import RoutesComponent from '../routers/routesComponent.js';
import history from '../routers/history';
import logoutAction from '../actions/logoutAction';
import restoreSession from '../actions/restoreSessionAction';
import {Scrollbars} from 'react-custom-scrollbars';
import './appMain.css';
import '../components/userProfileLogo.css';
import AppHeaderWithMenu from './appHeaderWithMenu'

class AppMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: true,
        };
        this.menuCollapseWithResize = this.menuCollapseWithResize.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    // menu collapse when on mobile function
    menuCollapseWithResize() {
        if (window.innerWidth < 991) {
            this.setState({menuOpen: false});
        }
        if (window.innerWidth > 991) {
            this.setState({menuOpen: true});
        }
    }

    // Sidebar collapse when tablet
    componentDidMount() {
        window.addEventListener('resize', this.menuCollapseWithResize);
        if (window.innerWidth < 991) {
            this.setState({menuOpen: false});
        }
        this.updateAndHandleLastSessionId();
    }

    updateAndHandleLastSessionId() {
        if (history.location.pathname === "/register") {
            return;
        }
        if (history.location.pathname === "/auth/spotify/callback") {
            return;
        }
        if (history.location.pathname === "/welcome" || history.location.pathname.lastIndexOf("/planningForm/",0) === 0) {
            this.setState({menuOpen: false});
            return;
        }
        let lastSessionId = localStorage.getItem("viboLastLogin");
        if (!lastSessionId) {
            history.push('/login');
        } else {
            this.props.restoreSession(lastSessionId);
            //let currentLocation = history.location;
            history.push('/');
            //  history.push(currentLocation);
        }
    }

    // Sidebar collapse when tablet
    componentWillUnmount() {
        window.removeEventListener('resize', this.menuCollapseWithResize);
    }

    // Sidebar toggle
    toggleMenu() {
        this.setState(prevState => ({
            menuOpen: !prevState.menuOpen
        }));
    }

    handleLogout() {
        localStorage.removeItem("viboLastLogin");
        this.props.logout();
        history.push('/login');
    }


    render() {

        // Page content class change based on menu toggle
        const pageContent = classNames({
            'app-page-content': true,
            'menu-open': this.state.menuOpen
        });

        // Sidebar class based on bg color
        const sidebarClass = classNames({
            'menu-drawer': true,
            'has-bg': true,
        });


        return (
            <Router history={history}>
                <div>
                    <div className="app-sidebar">
                        <AppHeaderWithMenu
                            visible = {this.props.loggedIn}
                            toggleMenu = {this.toggleMenu.bind(this)}
                            menuOpen = {this.state.menuOpen}
                        />
                        <Drawer open={this.props.loggedIn && this.state.menuOpen}
                                className={sidebarClass}
                                containerClassName="sidebar-initial-color"
                                zDepth = {0}
                        >
                            <Scrollbars>
                                <RoutesList
                                    handleLogout = {this.handleLogout.bind(this)}
                                    handleChangePage = {this.changeListComponentSelected}
                                />
                            </Scrollbars>
                        </Drawer>
                    </div>
                    <div className={pageContent}>
                        <RoutesComponent
                        />
                        {/*<Footer />*/}
                    </div>
                </div>
            </Router>

        );
    }
}

const mapStateToProps = (state) => ({
    loggedIn: state.user.loggedIn
})

const mapDispatchToProps = {
    logout: logoutAction,
    restoreSession: restoreSession
}

export default connect(mapStateToProps,mapDispatchToProps)(AppMain);



// WEBPACK FOOTER //
// ./src/containers/appMain.js